import { numberFormatter } from '@/common/utils.jsx'

export const getPaySlipMethods = (t) => ({
	XML: t('Esalary', 'Verkkopalkka'),
	Tuloste: t('Printout', 'Tuloste'),
	Sähköposti: t('Email', 'Sähköposti'),
})

export const getCompanyName = (businessIdToCompanyNameMap, businessId) => businessIdToCompanyNameMap?.[businessId] || ''

export const getNationalityLabel = (countryOptions, nationality) =>
	countryOptions.find((option) => option.value === nationality)?.label?.substring(4)

export const getDimensionValueGetter = (dimensionNumber, settings) => (params) => {
	const dimensions = params.data?.dimensions
	if (!dimensions) return

	const dim = dimensions.find((d) => d.codeKey === settings[`dim${dimensionNumber}key`])
	if (!dim) return

	const items = []
	for (const item of dim.items) {
		items.push(
			`${settings[`dim${dimensionNumber}map`]?.[item.codeKey] ?? item.codeKey}${item.percent < 100 ? ` (${item.percent}%)` : ''}`,
		)
	}

	return items.join(', ')
}

export const getSupplementColumns = (supplements, t) => {
	const columns = []

	for (let idx = 1; idx <= 16; ++idx) {
		const label = supplements[idx - 1]
		columns.push({
			headerName: label ?? `${t('Supplement', 'Lisä')} ${idx}`,
			field: `salaryDetails.supplement${idx}`,
			filter: 'agNumberColumnFilter',
			valueFormatter: numberFormatter,
			hide: true,
		})
	}

	return columns
}
